import React, { useRef, useEffect } from "react";
import "./About.css";
import HTMLFlipBook from "react-pageflip";
import { useDispatch, useSelector } from "react-redux";
import { fetchAboutData } from "../../redux/slices/aboutSlice";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n";

const About = () => {
  const dispatch = useDispatch();
  const bookRef = useRef();
const {t} = useTranslation('global');
  const { data: aboutData, isLoading, error } = useSelector((state) => state.about);

  useEffect(() => {
    dispatch(fetchAboutData(i18n.language));
  }, [dispatch, i18n.language]);
  console.log(aboutData)

  if (isLoading) return <div className="text-center py-5">جارٍ التحميل...</div>;
  if (error) return <div className="text-danger text-center">{error}</div>;

  return (
    <div className="about py-5" id="about">
      <div className="container">
        <h3 className="sub-color title text-center mt-2 mb-4">
          {t("about.heading")} <img src="/about.gif" alt={t("about.heading")} />
        </h3>

        <div className="row">
          <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
            <div className="book-wrapper position-relative">
              <HTMLFlipBook
                ref={bookRef}
                width={300}
                height={400}
                size="stretch"
                minWidth={200}
                maxWidth={1000}
                minHeight={300}
                maxHeight={1500}
                maxShadowOpacity={0.5}
                showCover={false}
                mobileScrollSupport={false} // Disable scroll on touch
                usePortrait={true}
                style={{ width: "100%", height: "auto" }}
              >
                <div className="page">
                  <img
                    src="/Products/1.jpg"
                    alt={t("about.heading")}
                    className="w-100 h-100 object-fit-cover rounded-3"
                  />
                </div>
                
                <div className="page">
                  <div className="about_text rounded-3">
                    <div>
                      <h5 className="text-white">{t("about.missionTitle")}</h5>
                      <p className="text-white line-height">{aboutData?.data?.mission}</p>
                    </div>
                  </div>
                </div>

                <div className="page">
                  <img
                    src="/Products/3.jpg"
                    alt={t("about.heading")}
                    className="w-100 h-100 object-fit-cover rounded-3"
                  />
                </div>
                <div className="page">
                  <div className="about_text rounded-3">
                    <div>
                      <h5 className="text-white">{t("about.visionTitle")}</h5>
                      <p className="text-white line-height">{aboutData?.data?.vision}</p>
                    </div>
                  </div>
                </div>

                <div className="page">
                  <img
                    src="/Products/4.jpg"
                    alt={t("about.heading")}
                    className="w-100 h-100 object-fit-cover rounded-3"
                  />
                </div>
              </HTMLFlipBook>

              {/* Tap zones for mobile click flipping */}
              <div className="tap-zone left" onClick={() => bookRef.current.pageFlip().flipPrev()} />
              <div className="tap-zone right" onClick={() => bookRef.current.pageFlip().flipNext()} />
            </div>
          </div>

          <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-down">
            <div className="line-height">
              <h4 style={{ fontWeight: "bold" }} className="text-color">
                Nile Gate Export
              </h4>
              <p className="line-height">{aboutData?.data?.about}</p>
            </div>
            <p className="line-height">{aboutData?.data?.mission}</p>
            <p className="line-height">{aboutData?.data?.vision}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
